import { Component, inject } from '@angular/core';
import { EdiInvoicesListConfigService } from '../../../services/edi-invoices-list-config/edi-invoices-list-config.service';

@Component({
    selector: 'lib-edi-invoices',
    template: `<lib-edi-list-wrapper
      [configService]="configService"
      title="EDI - Invoices">
    </lib-edi-list-wrapper>`,
    styleUrls: ['./edi-invoices.component.css'],
    standalone: false
})
export class EdiInvoicesComponent {
  public configService = inject(EdiInvoicesListConfigService);
}
